import { Component } from '@angular/core';
import { Store } from '@src/store';
import * as _ from "lodash";

@Component({
    selector: 'legend',
    template: require('./legend.html'),
    styles: [require('./legend.scss')]
})
export class LegendComponent {
    public legendClass:string;
    public isCollapsed:boolean = false;
    public editMode:boolean;

    constructor(private store:Store) {
        this.editMode = this.store.getState().project.editMode
     }

     toggleLegend(){
        this.isCollapsed = !this.isCollapsed;
        if (this.legendClass){
            this.legendClass = null;
        } else {
            this.legendClass = "hide-view";
        }
    }

 }




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/legend-ang7/legend.ts